import React from "react";
import Header from '../header';

export default function Navbar(props) {
  const [scroll, setScroll] = React.useState(0);

  const handleScroll = () => setScroll(document.documentElement.scrollTop);

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const className = scroll > 10 ? "fixed-navbar active" : "fixed-navbar";

  return (
    <div className={className}>
        <Header Logo={props.Logo} topbarBlock={props.topbarBlock} hclass={props.hclass}/>
    </div>
  ); 
}